import setDynamicFormFieldValue from "@iewccouk/Store/Handlers/DynamicForm/SetFieldValue";
import { CustomState } from "@iewccouk/Store/Reducers";
import { DynamicFormContext } from "@iewccouk/Widgets/DynamicForm/DynamicForm";
import { useRegisterDynamicFormFieldKeys } from "@iewccouk/Widgets/DynamicForm/useRegisterDynamicFormFieldKeys";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import React from "react";
import { connect, ResolveThunks } from "react-redux";

const enum fields {
    fieldKey = "fieldKey",
    value = "value",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.fieldKey]: string;
        [fields.value]: string;
    };
}

/** Maps Dynamic Form Redux state into widget props. */
const mapStateToProps = (state: CustomState, ownProps: OwnProps) => {
    const fieldKey = ownProps.fields.fieldKey || "Campaign_Code__c";
    return {
        fieldKey,
        fieldValue: state.customDynamicForm?.fieldValues[fieldKey],
    };
};

const mapDispatchToProps = {
    setDynamicFormFieldValue,
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

const widgetGroup = "SalesForce Dynamic" as any;

/** Salesforce Dynamic Form hidden field widget. */
const DynamicHidden: React.FC<Props> = ({
    id,
    fields: widgetFields,
    fieldKey,
    fieldValue,
    setDynamicFormFieldValue,
}) => {
    const { value } = widgetFields;
    const formContext = React.useContext(DynamicFormContext);
    useRegisterDynamicFormFieldKeys(id, [fieldKey]);

    React.useEffect(() => {
        if (fieldValue !== value) {
            setDynamicFormFieldValue({ key: fieldKey, value: value || "" });
        }
    }, [fieldKey, fieldValue, value, setDynamicFormFieldValue]);

    React.useEffect(() => {
        formContext.validators[fieldKey] = () => true;
        return () => {
            formContext.validators[fieldKey] = undefined;
        };
    }, [fieldKey, formContext.validators]);

    return null;
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(DynamicHidden),
    definition: {
        group: widgetGroup,
        displayName: "Hidden",
        icon: "eye-slash",
        fieldDefinitions: [
            {
                name: fields.fieldKey,
                displayName: "Salesforce Field (API Name)",
                editorTemplate: "TextField",
                fieldType: "General",
                defaultValue: "",
                isRequired: true,
            },
            {
                name: fields.value,
                displayName: "Value",
                editorTemplate: "TextField",
                fieldType: "General",
                defaultValue: "",
            },
        ],
    },
};

export default widgetModule;
